import { combineReducers } from "@reduxjs/toolkit";
import mainReducer from "./scenes/Main/main.slice";
import financialsReducer from "./scenes/Financials/financials.slice";

const rootReducer = combineReducers({
  main: mainReducer,
  financials: financialsReducer,
});

export default rootReducer;
